// @flow
import React, { Fragment, useState, useEffect } from "react";
import Button from "../Button";
import { post } from "../../lib/Fetching";

export default function InvoiceSampleChargeToolbar({ selectedSamples, reloadData }) {
  const [showActiveInvoices, setShowActiveInvoices] = useState(false);

  const handleRemoveCharges = () => {
    if (selectedSamples.length === 0) return;

    post("/invoicing/invoices/remove_ledger_items", {
      ledger_item_ids: selectedSamples.map(s => s.ledger_item_id)
    }).then(json => {
      reloadData();
    });
  };

  return (
    <div style={{ padding: 10 }}>
      <Button
        title="Remove Sample Charges"
        disabled={selectedSamples.length === 0}
        primary
        onClick={handleRemoveCharges}
      />
    </div>
  );
}
